import React, { Component, Fragment } from "react";
import ReactDOM from "react-dom";
import { Container, Col, Row, Label, Button, FormGroup, Modal } from "reactstrap";
import { themeService } from "../../../theme/service/activeTheme.service";
import { trackReportStyle } from "./style/index";
import "./style/style.css";
import InputDateField from "./inputdateField";
import FormFields from "../../../wigets/forms/formFields";
import { formFeildStyle } from "../../../wigets/forms/style/formFields";
//import DayPickerInput from "react-day-picker/DayPickerInput";
import { getLanguageLocal, languageService } from "Language/language.service";
//import MomentLocaleUtils from "react-day-picker/moment";
import ReportSelection from "./reportSelection.jsx";
import { CRUDFunction } from "../../../reduxCURD/container";
import { updateFilterState } from "reduxRelated/actions/filterStateAction";
import moment from "moment";
import _ from "lodash";
import SvgIcon from "react-icons-kit";
import { arrowLeft } from "react-icons-kit/icomoon/arrowLeft";
import { printer } from "react-icons-kit/icomoon/printer";
import { ExtendedMaterialUsageCSVMethod, MaterialUsageCSVMethod } from "../../Maintenance/MaintenanceDetailPage/MaterialUsageCSV.js";
import { AssetInspectionCSVMethod, LineInspectionCSVMethod } from "./CSVMethods.js";
import { getCurrentReportStateFilters, TEMPLATE_REPORT_FILTERS } from "./HelperFunctions/stateRetentionManagement";
import ReportFilterMenu from "./reportFilterMenu";
import { multiBorders } from "react-icons-kit/metrize/multiBorders";
import MultiReport from "./MultiReport";
import permissionCheck from "../../../utils/permissionCheck.js";
import { getUserSignature } from "../../../reduxRelated/actions/userActions";
import { filterInspecDefectCode, filterInspecAssetType, filterInspeDefectType } from "./HelperFunctions/reportFilterHelper";
import { assetTypesForIssues } from "../../../AssetTypeConfig/Reports/DefectReportConfig";
import { curdActions } from "../../../reduxCURD/actions";
import { versionInfo } from "../../MainPage/VersionInfo";
import { getAppMockupsTypes } from "../../../reduxRelated/actions/diagnosticsActions.js";
import SpinnerLoader from "../../Common/SpinnerLoader";
import { PillTextButton } from "../../../libraries/GeneralButtons/index.jsx";
import { getReportSummary } from "../../../reduxRelated/actions/reportSummaryActions.js";
import { isFraRole } from "../../MainPage/UserInfo.js";
import TooltipContainer from "../../../libraries/TooltipContainer/index.jsx";
import { WorkGangCSVMethod } from "../../Maintenance/MaintenanceDetailPage/WorkGangCSV.js";

const singatureReports = ["Line Inspection Report", "Detailed Switch Inspection"];

class ReportFilter extends Component {
  constructor(props) {
    super(props);
    this.stateRetentionObj = getCurrentReportStateFilters(
      this.props.stateRetentionObjName ? this.props[this.props.stateRetentionObjName] : this.props.reportSRFilter,
    );
    if (
      this.props.defaultActiveReport &&
      (!this.stateRetentionObj.reportTitle || !this.stateRetentionObj.reportName || !this.stateRetentionObj.reportId)
    ) {
      this.stateRetentionObj = { ...this.stateRetentionObj, ...this.props.defaultActiveReport };
    }
    this.state = {
      //dateRange: { from: new Date(moment().startOf("day")), today: new Date(moment().startOf("day")), to: new Date(moment().endOf("day")) },
      //InputObj: { ...InputObj },
      locationOptions: [],
      userOptions: [],
      issueAssetTypeOptions: [],
      defectCodeOptions: [],
      defectStatusOptions: [],
      //showReport: false,
      reportId: null,
      reports: [],
      allowPrint: true,
      multiReport: false,
      isMulti: false,
      showloader: false,
      //InspectionReportType: "Original",
      // reportName: "Line Inspection Report",
      // reportTitle: "Line Inspection & Repair Report",
      selectedInspections: [],
      inspectionsReport: [],
      ...this.stateRetentionObj,
      reportTypes: this.props.reportTypes ? this.props.reportTypes : [],
      disableRule213: false,
      materialUsageReportType: ""
    };

    //this.reportTypes = _.cloneDeep(defaultReportTypes);
    this.changeHandler = this.changeHandler.bind(this);
    this.updateDateRange = this.updateDateRange.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.printReport = this.printReport.bind(this);
    this.handelTabsClick = this.handelTabsClick.bind(this);
    this.getInspectionsFromServer = this.getInspectionsFromServer.bind(this);
    this.handleReportPrint = this.handleReportPrint.bind(this);
    this.handleReportPrintOff = this.handleReportPrintOff.bind(this);
    this.handleUpdateFilterState = this.handleUpdateFilterState.bind(this);
    this.getMultiReport = this.getMultiReport.bind(this);
    this.getSummaryDataFromServer = this.getSummaryDataFromServer.bind(this);
    this.getAssetInspectionDataFromServer = this.getAssetInspectionDataFromServer.bind(this);
  }
  setShowLoader(status) {
    this.setState({ showloader: status });
  }
  handleUpdateFilterState(propertiesToUpdate) {
    let stateRetentionObj = this.props.stateRetentionObjName
      ? this.props[this.props.stateRetentionObjName]
      : this.props.reportSRFilter
        ? this.props.reportSRFilter
        : {};

    this.props.updateFilterState(this.props.stateRetentionObjName ? this.props.stateRetentionObjName : "reportSRFilter", {
      ...stateRetentionObj,
      ...propertiesToUpdate,
    });
  }
  handleReportPrint() {
    this.setState({ allowPrint: true });
  }
  handleReportPrintOff() {
    this.setState({ allowPrint: false });
  }
  handelTabsClick(tabName) {
    let reportTitle = "";
    let reportId = "";
    this.state.reportTypes.map((type, i) => {
      if (type.name == tabName) {
        // this.state.reportTypes[i].active = true;
        reportId = this.state.reportTypes[i].reportId;
        reportTitle = this.state.reportTypes[i].title;
      }
      //  else this.state.reportTypes[i].active = false;
    });

    this.setState({
      reportTitle,
      reportName: tabName,
      reportId: reportId,
      reports: [],
      locationOptions: [],
      userOptions: [],
      defectCodeOptions: [],
      defectStatusOptions: [],
      issueAssetTypeOptions: [],
      InputObj: { ...this.state.InputObj },
    });
    this.handleUpdateFilterState({
      reportName: tabName,
      reportId: reportId,
      reportTitle: reportTitle,
      InputObj: { ...this.state.InputObj },
    });
    this.getRangeDataFromServer(this.state.dateRange, reportId);
  }
  changeHandler(e, blur) {
    let InputObj = { ...this.state.InputObj };
    InputObj[e.target.name] = e.target.value;
    let inspections = [...this.state.reports];
    // if (e.target.name == "user") inspections = this.filterByVals(InputObj);
    // if (e.target.name == "location") inspections = this.filterByVals(InputObj);
    // if (e.target.name == "defectCode") inspections = this.filterByVals(InputObj);
    // if (e.target.name == "assetType") inspections = this.filterByVals(InputObj);
    // if (e.target.name == "assetType") inspections = this.filterByVals(InputObj);
    inspections = this.filterByVals(InputObj);
    this.setState({
      InputObj: InputObj,
      reports: inspections,
      selectedInspections: inspections,
    });
    this.handleUpdateFilterState({
      InputObj: InputObj,
    });
  }

  filterByVals(InputObj) {
    let user = InputObj.user;
    let location = InputObj.location;
    let defectCode = InputObj.defectCode;
    let assetType = InputObj.assetType;
    let defectStatus = InputObj.defectStatus;

    let inspections = this.state.allReports;

    inspections = _.filter(inspections, (inspec) => {
      let userCheck = user == "All" ? true : false;
      let locationCheck = location == "All" ? true : false;
      let checkForAdditionalFilter = true;
      !userCheck && (userCheck = inspec.user.id == user);
      !locationCheck && (locationCheck = inspec.lineId == location);
      if (checkIfAdditionalFilter(this.state.reportName)) {
        let defectCodeCheck = defectCode == "All" ? true : false;
        let assetTypeCheck = assetType == "All" ? true : false;
        let defectStatusCheck = defectStatus == "All" ? true : false;
        !defectCodeCheck && (defectCodeCheck = filterInspecDefectCode(inspec, defectCode));
        !assetTypeCheck && (assetTypeCheck = filterInspecAssetType(inspec, assetType));
        !defectStatusCheck && (defectStatusCheck = filterInspeDefectType(inspec, defectStatus));
        checkForAdditionalFilter = assetTypeCheck && defectCodeCheck && defectStatusCheck;
      }

      return userCheck && locationCheck && checkForAdditionalFilter;
      //&& defectCodeCheck, assetTypeCheck;
    });
    return inspections;
  }

  updateDateRange(dateRange) {
    this.setState({
      dateRange: dateRange,
    });
    this.handleUpdateFilterState({
      dateRange: dateRange,
    });
    this.getRangeDataFromServer(dateRange, this.state.reportId);
  }

  componentDidMount() {
    this.handleUpdateFilterState(this.stateRetentionObj);
    this.getRangeDataFromServer(this.state.dateRange, this.state.reportId);
    //this.updateReportFilter();

    if (this.state.showReport === true) {
      this.getInspectionsFromServer([this.state.inspec]);
    }
    this.props.getApplicationlookupss("config");
    this.props.getAppMockupsTypes("materialTypes");
  }

  componentWillUnmount() {
    this.setShowLoader(false);
  }

  getMultiReport(type) {
    this.getInspectionsFromServer(this.state.selectedInspections);
    this.handleUpdateFilterState({
      InspectionReportType: type,
    });
    this.setState({ isMulti: true, InspectionReportType: type });
  }
  printReport() {
    if (this.state.isMulti) {
      document.title = languageService(this.state.reportTitle) + " Combined";
      window.print();
    } else {
      document.title = languageService(this.state.reportTitle);
      window.print();
    }
    let siteVersion = versionInfo.isSITE();
    document.title = siteVersion ? "SITE " : versionInfo.isBridge() ? "BIS" : "TIMPS";
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.props.reportTypes !== prevProps.reportTypes) {
      this.handleUpdateFilterState({ ...this.props.defaultActiveReport });
      this.getRangeDataFromServer(this.state.dateRange, this.props.defaultActiveReport.reportId);
      this.setState({ reportTypes: this.props.reportTypes, ...this.props.defaultActiveReport });
    }

    if (prevProps.diagnosticsActionType !== this.props.diagnosticsActionType) {
      if (this.props.diagnosticsActionType === "GET_MATERIALTYPES_SUCCESS") {
        this.setShowLoader(false);
      }

      if (this.props.diagnosticsActionType === "GET_MATERIALTYPES_REQUEST") {
        this.setShowLoader(true);
      } else if (this.props.diagnosticsActionType === "GET_MATERIALTYPES_FAILURE") {
        this.setShowLoader(false);
      }
    }
    if (this.props.actionType !== prevProps.actionType && this.props.reportFilter) {
      if (this.props.actionType == "REPORTFILTER_READ_SUCCESS") {
        this.setShowLoader(false);
        let multiOption = false;
        if (this.props.reportFilter.length > 0) {
          let check = this.props.reportFilter.filter((item) => {
            return item.status == "Finished";
          });
          if (check.length > 0) {
            multiOption = true;
          } else {
            multiOption = false;
          }
        }

        this.loadReportsData(this.props.reportFilter);
        let multi = this.props.reportFilter && (multiOption ? true : false);
        this.setState({ multiReport: multi, allReports: this.props.reportFilter });
      } else if (this.props.actionType == "REPORTFILTER_READ_REQUEST") {
        this.setShowLoader(true);
      } else if (this.props.actionType == "REPORTFILTER_READ_FAILURE") {
        this.setShowLoader(false);
      }
    }

    // Amir: received all reports data
    if (this.props.actionType !== prevProps.actionType) {
      if (this.props.actionType == "REPORTFILTER_CREATE_SUCCESS") {
        this.setShowLoader(false);
        if (this.props.reportFilter) {
          // get all required signatures urls
          this.getUserSignaturesForInspections(this.props.reportFilter);
          this.setState({ inspectionsReport: this.props.reportFilter });
        }
      } else if (this.props.actionType == "REPORTFILTER_CREATE_REQUEST") {
        this.setShowLoader(true);
      } else if (this.props.actionType == "REPORTFILTER_CREATE_FAILURE") {
        this.setShowLoader(false);
      }
    }

    if (this.props.userActionType !== prevProps.userActionType) {
      if (this.props.userActionType === "GET_USERS_SIGNATURE_SUCCESS") {
        this.setShowLoader(false);
        this.fillSignatureImageWithUserObj(this.props.usersSignatures);
        this.setState({ showReport: true });
        this.handleUpdateFilterState({
          showReport: true,
        });
      } else if (this.props.userActionType == "GET_USERS_SIGNATURE_REQUEST") {
        this.setShowLoader(true);
      } else if (this.props.userActionType == "GET_USERS_SIGNATURE_FAILURE") {
        this.setShowLoader(false);
      }
    }

    if (prevProps.applicationlookupsActionType !== this.props.applicationlookupsActionType) {
      if (this.props.applicationlookupsActionType === "APPLICATIONLOOKUPSS_READ_SUCCESS") {
        this.setShowLoader(false);
        const { applicationlookupss } = this.props;
        if (Array.isArray(applicationlookupss)) {
          const reportStartRange = applicationlookupss.find((l) => l.code === "reportStartRange");
          const disableRule213 = applicationlookupss.find((l) => l.code === "disableRule213");
          if (!this.state.reportMinStartDate) {
            let reportStart = new Date(reportStartRange && reportStartRange.opt2);
            // limit report Date to 2 years if FRA role and production date older than 2 years
            if (isFraRole()) {
              const FRAReportStart = new Date(new Date().setFullYear(new Date().getFullYear() - 2));

              reportStart = Date.parse(reportStart) && FRAReportStart.getTime() < reportStart.getTime() ? reportStart : FRAReportStart;
            }

            this.setState({
              reportMinStartDate: reportStart,
            });
          }
          this.setState({ disableRule213: disableRule213 && disableRule213.opt2 });
        }
      } else if (this.props.applicationlookupsActionType == "APPLICATIONLOOKUPSS_READ_REQUEST") {
        this.setShowLoader(true);
      } else if (this.props.applicationlookupsActionType == "APPLICATIONLOOKUPSS_READ_FAILURE") {
        this.setShowLoader(false);
      }
    }

    if (prevProps.reportSummaryActionType !== this.props.reportSummaryActionType) {
      if (this.props.reportSummaryActionType === "MATERIALUSAGECSV_GET_SUCCESS") {
        let range = this.state.dateRange;
        const formattedFromDate = moment(range.from).format("D MMM YY");
        const formattedToDate = moment(range.to).format("D MMM YY");

        let dateRange = `${formattedFromDate} - ${formattedToDate}`;
        dateRange = dateRange.toString();
        this.state.materialUsageReportType === 'extended' ?
          ExtendedMaterialUsageCSVMethod(this.props.materialUsageCSVSummary, dateRange, this.props.materialTypes) :
          MaterialUsageCSVMethod(this.props.materialUsageCSVSummary, dateRange, this.props.materialTypes)
        this.setState({ materialUsageReportType: "" })
      }
    }

    if (prevProps.reportSummaryActionType !== this.props.reportSummaryActionType) {
      if (this.props.reportSummaryActionType === "WORKGANGCSV_GET_SUCCESS") {
        let range = this.state.dateRange;
        const formattedFromDate = moment(range.from).format("D MMM YY");
        const formattedToDate = moment(range.to).format("D MMM YY");

        let dateRange = `${formattedFromDate} - ${formattedToDate}`;
        dateRange = dateRange.toString();
        WorkGangCSVMethod(this.props.workGangCSVSummary, dateRange, this.props.materialTypes);
      }
    }

    if (prevProps.reportSummaryActionType !== this.props.reportSummaryActionType) {
      if ((this.props.reportSummaryActionType || "").includes("_SUCCESS")) {
        this.setShowLoader(false);
      }
      if ((this.props.reportSummaryActionType || "").includes("_REQUEST")) {
        this.setShowLoader(true);
      }
      if ((this.props.reportSummaryActionType || "").includes("_FAILURE")) {
        this.setShowLoader(false);
      }
    }
    if (prevProps.reportSummaryActionType !== this.props.reportSummaryActionType) {
      if (this.props.reportSummaryActionType === "LINEINSPECTIONCSV_GET_SUCCESS") {
        let range = this.state.dateRange;
        const formattedFromDate = moment(range.from).format("MM/DD/YYYY");
        const formattedToDate = moment(range.to).format("MM/DD/YYYY");
        let dateRange = `${formattedFromDate} - ${formattedToDate}`;
        LineInspectionCSVMethod(this.props.lineInspectionCSVSummary, dateRange);
      }
    }
    if (prevProps.reportSummaryActionType !== this.props.reportSummaryActionType) {
      if (this.props.reportSummaryActionType === "ASSETINSPECTIONCSV_GET_SUCCESS") {
        let range = this.state.dateRange;
        const formattedFromDate = moment(range.from).format("MM/DD/YYYY");
        const formattedToDate = moment(range.to).format("MM/DD/YYYY");
        let dateRange = `${formattedFromDate} - ${formattedToDate}`;
        AssetInspectionCSVMethod(this.props.assetInspectionCSVSummary, dateRange);
      }
    }
  }
  handleBack() {
    this.setState({
      showReport: false,
      isMulti: false,
      allowPrint: true,
    });
    this.handleUpdateFilterState({
      showReport: false,
    });
  }
  handleClick(inspec, type) {
    this.getInspectionsFromServer([inspec]);
    this.handleUpdateFilterState({
      inspec: inspec,
      InspectionReportType: type,
    });
    this.setState({ InspectionReportType: type });
  }
  loadReportsData(inspections) {
    let locationOptions = [];
    let userOptions = [];
    let defectCodeOptions = [];
    let issueAssetTypeOptions = [];
    let defectStatusOptions = [];
    let addtionalCheck = checkIfAdditionalFilter(this.state.reportName);
    if (_.isArray(inspections)) {
      locationOptions.push({ val: "All", text: "All" });

      if (addtionalCheck) {
        defectCodeOptions.push({ val: "All", text: "All" });
        issueAssetTypeOptions.push({ val: "All", text: "All" });
        inspections.length > 0
          ? (defectStatusOptions = [
            { val: "All", text: "All" },
            { val: "Open", text: "Open" },
            { val: "Closed", text: "Closed" },
          ])
          : (defectStatusOptions = [{ val: "All", text: "All" }]);
      }
      inspections.forEach((inspec) => {
        let locFilled = _.find(locationOptions, { val: inspec.lineId });
        let userFilled = _.find(userOptions, { val: inspec.user.id });
        if (!locFilled) locationOptions.push({ val: inspec.lineId, text: inspec.lineName });
        if (!userFilled) userOptions.push({ val: inspec.user.id, text: inspec.user.name });
        addtionalCheck &&
          inspec.issues &&
          inspec.issues.forEach((issue) => {
            let allowedIssueAssetType = _.find(assetTypesForIssues, (item) => item === issue.unit.assetType);
            if (allowedIssueAssetType) {
              issue.unit && issueAssetTypeOptions.push({ val: issue.unit.assetType, text: issue.unit.assetType });
              issue.defectCodes &&
                issue.defectCodes.forEach((dCode) => {
                  if (dCode) defectCodeOptions.push({ val: dCode, text: dCode });
                });
            }
          });
      });
      defectCodeOptions.length > 0 &&
        (defectCodeOptions = _.uniqBy(defectCodeOptions, (item) => {
          return item.val;
        }));
      issueAssetTypeOptions.length > 0 &&
        (issueAssetTypeOptions = _.uniqBy(issueAssetTypeOptions, (item) => {
          return item.val;
        }));

      inspections = inspections.sort((a, b) => {
        const a1 = new Date(a.date).getTime();
        const b1 = new Date(b.date).getTime();
        if (a1 < b1) return 1;
        else if (a1 > b1) return -1;
        else return 0;
      });
      let addtional = {};
      if (addtionalCheck) {
        addtional = {
          defectCode: defectCodeOptions[0].val,
          assetType: issueAssetTypeOptions[0].val,
          defectStatus: defectStatusOptions[0].val,
        };
      }
      userOptions = _.sortBy(userOptions, ["text"]);
      userOptions.unshift({ val: "All", text: "All" });
      this.setState({
        locationOptions,
        userOptions,
        defectCodeOptions,
        issueAssetTypeOptions,
        defectStatusOptions,
        reports: inspections,
        InputObj: {
          location: locationOptions[0].val,
          user: userOptions[0].val,
          ...addtional,
        },
        selectedInspections: inspections,
      });
      this.handleUpdateFilterState({
        InputObj: {
          location: locationOptions[0].val,
          user: userOptions[0].val,
          ...addtional,
        },
      });
    }
  }

  getRangeDataFromServer(range, activeReportId) {
    let isBriefing = this.state.reportName === "Safety Briefing";
    var jsonArray = encodeURIComponent(JSON.stringify(range));
    let activeReport = _.find(this.state.reportTypes, { reportId: activeReportId });
    let arg = (isBriefing ? "jobBriefing/report/inspection/?dateRange=" : "report/inspection/?dateRange=") + jsonArray;
    if (activeReport) {
      arg = arg + "&rId=" + activeReport.reportId;
    }
    this.props.getReportFilter(arg);
  }

  getSummaryDataFromServer(range, location, user, report) {
    var jsonArray = encodeURIComponent(JSON.stringify(range));
    let reportName = report;
    let arg = "summary/?dateRange=" + jsonArray;

    arg = arg + "&name=" + reportName + "&lineId=" + location + "&userId=" + user;

    this.props.getReportSummary(arg, reportName);
  }
  getLineInspectionSummaryDataFromServer(range, location, user, report) {
    var jsonArray = encodeURIComponent(JSON.stringify(range));
    let reportName = report;
    let arg = "lineInspectionCSV/?dateRange=" + jsonArray;

    arg = arg + "&name=" + reportName + "&lineId=" + location + "&userId=" + user + "&nonFRA" + this.props.nonFraCode;

    this.props.getReportSummary(arg, reportName);
  }
  getAssetInspectionDataFromServer(range, location, user, report) {
    var jsonArray = encodeURIComponent(JSON.stringify(range));
    let reportName = report;
    let arg = "assetInspectionCSV/?dateRange=" + jsonArray;

    arg = arg + "&name=" + reportName + "&lineId=" + location + "&userId=" + user;

    this.props.getReportSummary(arg, reportName);
  }
  getInspectionsFromServer(inspections) {
    if (inspections.length > 0) {
      let inspecs = [];
      inspections.forEach((inspec, index) => {
        if (inspec.status == "Finished") {
          inspecs.push(inspec._id);
        }
      });
      this.props.createReportFilter(inspecs, null, "/report");
    }
  }
  getUserSignaturesForInspections(inspections) {
    let users = [];
    inspections.forEach((inspec) => {
      let existCheck = _.find(users, (email) => email == inspec.user.email);
      if (!existCheck) users.push(inspec.user.email);
      let issues = inspec.tasks && inspec.tasks[0] && inspec.tasks[0].issues;
      issues &&
        issues.forEach((issue) => {
          if (issue && issue.serverObject && issue.serverObject.repairedBy) {
            let mUserExist = _.find(users, (email) => email == issue.serverObject.repairedBy.email);
            !mUserExist && users.push(issue.serverObject.repairedBy.email);
          }
        });
    });

    let ulength = users.length;
    if (ulength) {
      let query = "?";
      users.forEach((email, index) => {
        let andToAdd = index == ulength - 1 ? "" : "&";
        query = query + "emails[]=" + email + andToAdd;
      });
      this.props.getUserSignature(query);
    }
  }
  fillSignatureImageWithUserObj(userSigs) {
    let inspections = [...this.state.inspectionsReport];
    inspections.forEach((inspec) => {
      inspec.sigs = userSigs;
      let foundUser = _.find(userSigs, { email: inspec.user.email });
      if (foundUser && foundUser.signature) {
        inspec.user = { ...inspec.user };
        inspec.user.signature = foundUser.signature.imgName;
      }
    });
    this.setState({
      inspectionsReport: inspections,
    });
  }

  render() {
    const { from, to } = this.state.dateRange;
    const modifiers = { start: from, end: to };

    return (
      <React.Fragment>
        {!this.state.showReport && (
          <div className="mainContent" style={{ textAlign: "center" }}>
            <SpinnerLoader spinnerLoading={this.state.showloader} />
            <Row style={{ marginRight: "0" }}>
              <Col md={10}>
                <ReportFilterMenu
                  reports={this.state.reportTypes}
                  activeReportId={this.state.reportId}
                  handelTabsClick={this.handelTabsClick}
                />
              </Col>
              <Col md={2}>
                {this.state.multiReport && (
                  //       for Multi report
                  <span
                    style={{
                      cursor: "pointer",
                      textAlign: "right",
                      display: "block",
                      textAlign: "center",
                      margin: "10px 15px 0 0",
                      width: "fit-content",
                      float: "right",
                    }}
                    onClick={(e) => {
                      this.getMultiReport("All");
                    }}
                  >
                    <span
                      style={{ verticalAlign: "super", marginRight: "5px", fontSize: "12px", display: "block", whiteSpace: "break-spaces" }}
                    >
                      {languageService("Bulk Print \n All")}
                    </span>
                    <SvgIcon size={32} icon={multiBorders} />
                  </span>
                )}
                {this.state.multiReport && this.state.reportName === "Line Inspection Report" && (
                  //       for Multi report
                  <span
                    style={{
                      cursor: "pointer",
                      textAlign: "right",
                      display: "block",
                      textAlign: "center",
                      margin: "10px 15px 0 0",
                      width: "fit-content",
                      float: "right",
                    }}
                    onClick={(e) => {
                      this.getMultiReport("Original");
                    }}
                  >
                    <span
                      style={{ verticalAlign: "super", marginRight: "5px", fontSize: "12px", display: "block", whiteSpace: "break-spaces" }}
                    >
                      {languageService("Bulk Print")}
                      {"\n"}
                      {languageService("Original")}
                    </span>
                    <SvgIcon size={32} icon={multiBorders} />
                  </span>
                )}
              </Col>
            </Row>

            <Col md={12}>
              <div className={"commonform"} style={{ ...themeService(trackReportStyle.mainStyle), background: "transparent" }}>
                {
                  <React.Fragment>
                    <h2 style={{ ...themeService(trackReportStyle.headingStyle), transform: "none", fontSize: "22px" }}>
                      {languageService(this.state.reportTitle)}
                    </h2>
                    <div className="report-filter">
                      <label style={themeService(trackReportStyle.labelStyle)}>{languageService("Select a Date Range")}</label>
                      <span style={themeService(trackReportStyle.dateStyle)}>
                        <InputDateField
                          disabledDays={this.state.reportMinStartDate ? { before: new Date(this.state.reportMinStartDate) } : null}
                          minReportDate={this.state.reportMinStartDate}
                          updateDateRange={this.updateDateRange}
                          defaultDate={this.state.dateRange}
                        />
                      </span>
                      <div className="report-filter"></div>
                      {this.state.locationOptions && this.state.locationOptions.length > 0 && (
                        <SelectField
                          inputFieldProps={{ name: "location", label: "Location" }}
                          options={this.state.locationOptions}
                          changeHandler={this.changeHandler}
                          value={this.state.InputObj.location}
                        />
                      )}
                      <div className="report-filter"></div>
                      {this.state.userOptions && this.state.userOptions.length > 0 && (
                        <SelectField
                          inputFieldProps={{ name: "user", label: "User" }}
                          options={this.state.userOptions}
                          changeHandler={this.changeHandler}
                          value={this.state.InputObj.user}
                        />
                      )}
                      {
                        <React.Fragment>
                          <div className="report-filter"></div>
                          {this.state.defectCodeOptions && this.state.defectCodeOptions.length > 0 && (
                            <SelectField
                              inputFieldProps={{ name: "defectCode", label: "Defect code" }}
                              options={this.state.defectCodeOptions}
                              changeHandler={this.changeHandler}
                              value={this.state.InputObj.defectCode}
                            />
                          )}
                          <div className="report-filter"></div>
                          {this.state.issueAssetTypeOptions && this.state.issueAssetTypeOptions.length > 0 && (
                            <SelectField
                              inputFieldProps={{ name: "assetType", label: "AssetType" }}
                              options={this.state.issueAssetTypeOptions}
                              changeHandler={this.changeHandler}
                              value={this.state.InputObj.assetType}
                            />
                          )}
                          {this.state.defectStatusOptions && this.state.defectStatusOptions.length > 0 && (
                            <SelectField
                              inputFieldProps={{ name: "defectStatus", label: "Defect status" }}
                              options={this.state.defectStatusOptions}
                              changeHandler={this.changeHandler}
                              value={this.state.InputObj.defectStatus}
                            />
                          )}
                        </React.Fragment>
                      }
                    </div>
                  </React.Fragment>
                }
              </div>
            </Col>

            {this.state.reportName === "Daily Material Usage Report" && (
              <Col
                md={11}
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                {permissionCheck("MATERIAL USAGE REPORT SUMMARY", "view") && (
                  <Fragment>
                    <TooltipContainer tooltipText={languageService("WO Material Usage Summary CSV")}>
                      <PillTextButton
                        title={languageService("W/O MT Usage Summary CSV")}
                        onClick={(e) => {
                          this.setState({
                            materialUsageReportType: "normal"
                          })
                          this.getSummaryDataFromServer(
                            this.state.dateRange,
                            this.state.InputObj.location,
                            this.state.InputObj.user,
                            "materialUsageCSV",
                          );
                        }}
                        style={{ fontSize: "12px", width: "max-content" }}
                      />
                    </TooltipContainer>
                    <TooltipContainer tooltipText={languageService("Material Usage by Execution CSV")}>
                      <PillTextButton
                        title={languageService("Material Usage by Execution CSV")}
                        onClick={(e) => {
                          this.setState({
                            materialUsageReportType: "extended"
                          })
                          this.getSummaryDataFromServer(
                            this.state.dateRange,
                            this.state.InputObj.location,
                            this.state.InputObj.user,
                            "materialUsageCSV",
                          );
                        }}
                        style={{ fontSize: "12px", width: "max-content" }}
                      />
                    </TooltipContainer>
                  </Fragment>
                )}
              </Col>
            )}

            {this.state.reportName === "Work Gang Report" && (
              <Col
                md={11}
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <TooltipContainer tooltipText={languageService("Work Gang CSV")}>
                  <PillTextButton
                    title={languageService("Work Gang CSV")}
                    onClick={(e) => {
                      this.getSummaryDataFromServer(
                        this.state.dateRange,
                        this.state.InputObj.location,
                        this.state.InputObj.user,
                        "workGangCSV",
                      );
                    }}
                    style={{ fontSize: "12px", width: "max-content" }}
                  />
                </TooltipContainer>
              </Col>
            )}

            {this.state.reportName === "Line Inspection Report" && this.state.reports.length > 0 && (
              <Col
                md={11}
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <TooltipContainer tooltipText={languageService("Inspected Assets CSV")}>
                  <PillTextButton
                    title={languageService("Inspected Assets CSV")}
                    onClick={(e) => {
                      this.getAssetInspectionDataFromServer(
                        this.state.dateRange,
                        this.state.InputObj.location,
                        this.state.InputObj.user,
                        "assetInspectionCSV",
                      );
                    }}
                    style={{ fontSize: "12px", width: "max-content" }}
                  />
                </TooltipContainer>
                <TooltipContainer tooltipText={languageService("Detailed Summary CSV")}>
                  <PillTextButton
                    title={languageService("Detailed Summary CSV")}
                    onClick={(e) => {
                      this.getLineInspectionSummaryDataFromServer(
                        this.state.dateRange,
                        this.state.InputObj.location,
                        this.state.InputObj.user,
                        "lineInspectionCSV",
                      );
                    }}
                    style={{ fontSize: "12px", width: "max-content" }}
                  />
                </TooltipContainer>
              </Col>
            )}

            <ReportSelection reportFilter={this.state.reports} handleClick={this.handleClick} reportName={this.state.reportName} />
          </div>
        )}

        {this.state.showReport && (
          <React.Fragment>
            <div className="report-controls" style={{ width: "100%", marginBottom: "60px", padding: "15px", minWidth: "250px" }}>
              <div
                className="report-arrow"
                style={{ margin: "15px 15px 10px 0", cursor: "pointer", float: "left", textAlign: "center" }}
                onClick={(e) => {
                  this.handleBack();
                }}
              >
                <span style={{ verticalAlign: "super", marginLeft: "5px", fontSize: "12px", display: "block" }}>
                  {languageService("Reports Menu")}
                </span>
                <SvgIcon icon={arrowLeft} size={24} />
              </div>
              {this.state.allowPrint && (
                <div
                  className="report-print"
                  style={{ margin: "15px 0 0 15px", cursor: "pointer", float: "right", textAlign: "center" }}
                  onClick={(e) => {
                    this.printReport();
                  }}
                >
                  <span style={{ verticalAlign: "super", marginRight: "5px", fontSize: "12px", display: "block" }}>
                    {languageService("Print Report")}
                  </span>
                  <SvgIcon icon={printer} size={24} />
                </div>
              )}
            </div>

            <div className="mainContent">
              <MultiReport
                reportName={this.state.reportName}
                handleBack={this.handleBack}
                reportInspections={this.state.inspectionsReport}
                printbuttonhandler={{ show: this.handleReportPrint, hide: this.handleReportPrintOff }}
                isMulti={this.state.isMulti}
                InspectionReportType={this.state.InspectionReportType}
                usersSignatures={this.props.usersSignatures}
                nonFraCode={this.props.nonFraCode}
                disableRule213={this.state.disableRule213}
                materialTypes={this.props.materialTypes}
              />
            </div>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}
let variables = {
  filterStateReducer: {
    reportSRFilter: null,
    safetyBriefingRetention: null,
    siteWoRetention: null,
  },
  userReducer: {
    usersSignatures: [],
  },
  applicationlookupsReducer: { applicationlookupss: [] },

  diagnosticsReducer: {
    materialTypes: [],
  },

  reportSummaryReducer: {
    materialUsageCSVSummary: [],
    workGangCSVSummary: [],
    lineInspectionCSVSummary: [],
    assetInspectionCSVSummary: [],
  },
};
const getApplicationlookupss = curdActions.getApplicationlookupss;
let actionOptions = {
  create: true,
  update: false,
  read: true,
  delete: false,
  others: { updateFilterState, getUserSignature, getApplicationlookupss, getAppMockupsTypes, getReportSummary },
};
let ReportFilterCRUD = CRUDFunction(
  ReportFilter,
  "reportFilter",
  actionOptions,
  variables,
  ["filterStateReducer", "userReducer", "applicationlookupsReducer", "diagnosticsReducer", "reportSummaryReducer"],
  "journeyPlan",
);
export default ReportFilterCRUD;
export const SelectField = (props) => {
  return (
    <div style={{ ...themeService(formFeildStyle.feildStyle), display: "inline-block", margin: "0" }}>
      {props.inputFieldProps.label && (
        <label style={{ ...themeService(formFeildStyle.lblStyle), width: "inherit", margin: "5px 5px 5px" }}>
          {languageService(props.inputFieldProps.label) + ":"}
        </label>
      )}
      <select
        style={{ ...themeService(formFeildStyle.inputStyle), width: "inherit", cursor: "pointer" }}
        onChange={(e) => props.changeHandler(e, false, "select")}
        onBlur={(e) => props.changeHandler(e, true, "select")}
        {...props.inputFieldProps}
        value={props.value}
      >
        {props.options &&
          props.options.map((item, index) => (
            <option key={index} value={item.val}>
              {languageService(item.text)}
            </option>
          ))}
      </select>
    </div>
  );
};

export class SearchableSelectField extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      searchText: "",
    };
    this.wrapperRef = React.createRef();
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside(event) {
    if (this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) {
      this.setState({ isOpen: false, searchText: "" });
    }
  }

  handleSelect = (option) => {
    const event = {
      target: {
        name: this.props.inputFieldProps.name,
        value: option.val,
      },
    };
    this.props.changeHandler(event);
    this.setState({ isOpen: false, searchText: "" });
  };

  handleTriggerClick = () => {
    this.setState((prevState) => ({
      isOpen: !prevState.isOpen,
      searchText: !prevState.isOpen ? "" : prevState.searchText,
    }));
  };

  handleSearchChange = (e) => {
    this.setState({ searchText: e.target.value });
  };

  clearSearch = (e) => {
    e.stopPropagation();
    this.setState({ searchText: "" });
  };

  render() {
    const { isOpen, searchText } = this.state;
    const selectedOption = this.props.options && this.props.options.find((opt) => opt.val === this.props.value);
    const filteredOptions =
      this.props.options && this.props.options.filter((opt) => languageService(opt.text).toLowerCase().includes(searchText.toLowerCase()));

    return (
      <div
        ref={this.wrapperRef}
        style={{ ...themeService(formFeildStyle.feildStyle), display: "inline-block", margin: "0", position: "relative" }}
      >
        {this.props.inputFieldProps.label && (
          <label style={{ ...themeService(formFeildStyle.lblStyle), width: "inherit", margin: "5px 5px 5px" }}>
            {languageService(this.props.inputFieldProps.label) + ":"}
          </label>
        )}
        <select
          style={{ ...themeService(formFeildStyle.inputStyle), width: "inherit", cursor: "pointer" }}
          onChange={() => { }}
          value={this.props.value}
          onClick={this.handleTriggerClick}
        >
          {selectedOption && <option value={selectedOption.val}>{languageService(selectedOption.text)}</option>}
        </select>
        {isOpen && (
          <div
            style={{
              position: "fixed",
              top: "auto",
              left: "auto",
              right: "auto",
              backgroundColor: "#fff",
              border: "1px solid #ccc",
              zIndex: 10000,
              maxHeight: "250px",
              overflowY: "auto",
              minWidth: "200px",
              marginTop: "-1px",
            }}
          >
            <div
              style={{
                padding: "6px",
                borderBottom: "1px solid #eee",
                display: "flex",
                alignItems: "center",
                position: "sticky",
                top: 0,
                backgroundColor: "#fff",
              }}
            >
              <input
                type="text"
                value={searchText}
                onChange={this.handleSearchChange}
                placeholder="Search..."
                style={{ flex: 1, padding: "4px 8px", border: "1px solid #ddd", borderRadius: "3px", fontSize: "12px" }}
                autoFocus
                onClick={(e) => e.stopPropagation()}
              />
              {searchText && (
                <span onClick={this.clearSearch} style={{ marginLeft: "8px", cursor: "pointer", color: "#666", fontWeight: "bold" }}>
                  ✕
                </span>
              )}
            </div>
            {filteredOptions &&
              filteredOptions.map((option, index) => (
                <div
                  key={index}
                  onClick={() => this.handleSelect(option)}
                  style={{
                    padding: "6px 12px",
                    cursor: "pointer",
                    backgroundColor: option.val === this.props.value ? "#f0f0f0" : "white",
                    fontSize: "12px",
                    textAlign: "left",
                  }}
                  onMouseEnter={(e) => (e.target.style.backgroundColor = "#f5f5f5")}
                  onMouseLeave={(e) => (e.target.style.backgroundColor = option.val === this.props.value ? "#f0f0f0" : "white")}
                >
                  {languageService(option.text)}
                </div>
              ))}
            {filteredOptions && filteredOptions.length === 0 && (
              <div style={{ padding: "8px 12px", color: "#999", fontStyle: "italic", fontSize: "12px" }}>No options found</div>
            )}
          </div>
        )}
      </div>
    );
  }
}

function checkIfAdditionalFilter(reportName) {
  return additionalFilters.find((rName) => reportName === rName);
}
const additionalFilters = ["Line Inspection Report", "Line Inspection and Repair Report"];



// WEBPACK FOOTER //
// ./src/components/Reports/Timps/reportfilter.jsx